/**
 * Constant containing the id of the currently build version.
 */
export type Version = string;

export const VersionProvider: {
  provide: string;
  useValue: Version;
} = {
  provide: 'version',
  useValue: 'v25.28.1-11-g5fb9581',
};
